'use strict';

angular.module('cloudBillingLegacyFrontend').controller('EaSecuredAreaCtrl', [ '$scope', '$eaCurrentSession', function ($scope, $eaCurrentSession) {

  // defined some view related information
  $scope.authorized = ($eaCurrentSession !== null && $eaCurrentSession  !== undefined);
  $scope.currentSession = $eaCurrentSession;  
  $scope.token = $eaCurrentSession.DataToken;

}]);
